import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

export default styled(Switch)(({ theme, checked }) => ({
  "& .MuiSwitch-switchBase": {
    color: checked ? "#4caf50" : theme.palette.error.main, // Always green when checked
    "&.Mui-checked": {
      color: "#4caf50",
      "& + .MuiSwitch-track": {
        backgroundColor: "gray",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: "gray",
    opacity: 1,
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: checked ? "#4caf50" : theme.palette.error.main,
  },
}));
